

// 获取今天的时间
export const getTodayTime =()=>{
    let currentime = new Date()
    let year = currentime.getFullYear()
    let month = currentime.getMonth() + 1
    let day = currentime.getDate()
    return correction(year) + '-' + correction(month) + '-' + correction(day)
}

// 获取今天和昨天的时间
export const getTodayYesTime =()=>{
    let currentime = new Date()
    let year = currentime.getFullYear()
    let month = currentime.getMonth() + 1
    let day = currentime.getDate()
    // console.log(year,month,day);
    let yesterday = new Date(currentime)
    yesterday.setDate(yesterday.getDate() - 1)
    let yesyear = yesterday.getFullYear()
    let yesmonth = yesterday.getMonth() + 1
    let yesday = yesterday.getDate() 
    let time = {
        today : correction(year) + '-' + correction(month) + '-' + correction(day),
        yesterday : correction(yesyear) + '-' + correction(yesmonth) + '-' + correction(yesday)
    }
    return time
}

// 一位数前补0
const correction = (time)=>{
    return time>=0 && time<10 ? '0'+time :time
}

// 获取当前月的时间
export const getMonthTime =()=>{
    let currentime = new Date()
    let year = currentime.getFullYear()
    let month = currentime.getMonth() + 1
    let day = currentime.getDate()
    let time = {
        end : correction(year) + '-' + correction(month) + '-' + correction(day),
        start : correction(year) + '-' + correction(month) + '-1'
    }
    return time
}

// 获取最近7天的时间 
export const getSevenDays =()=>{

    let time = {
        one : getOneDay(0),
        two : getOneDay(-1),
        three : getOneDay(-2),
        four : getOneDay(-3),
        five : getOneDay(-4),
        six : getOneDay(-5),
        seven : getOneDay(-6),
    }
    return time
}

// 测试获取最近7天的日期
const getOneDay = (day)=>{
    let today = new Date();
    let targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    let tYear = today.getFullYear();
    let tMonth = today.getMonth();
    let tDate = today.getDate();
    tMonth = correction(tMonth + 1);
    tDate = correction(tDate);
    return tYear+"-"+tMonth+"-"+tDate;
}

// 获取当前月份的所有日期
export const getMonthDays =()=>{
    let year = new Date().getFullYear()
    let month = new Date().getMonth() + 1
    let day = new Date(year, month, 0).getDate()
    let current_month_num = day
    let current_month = []
    for(let i = 1;i <= current_month_num;i++){
        let cday = month + '-' + i
        current_month.push(cday)
    }
    return current_month
}

export const pageAlarm =(arr, page)=>{
    let newArr = []
    for(let i = 0;i <arr.length;i = page+i){
        newArr.push(arr.slice(i , i+page))
    }
    return newArr
}
// 获取上个月最后一天的日期
export const lastMonth =()=>{
    let date = new Date()
    let year = date.getFullYear()
    let mon = date.getMonth() 
    if(mon == 0){
        mon = 12
        year = year - 1
    }
    let lastDay = new Date(year, mon, 0).getDate()
    return year + "-" + correction(mon) + "-" +lastDay
}